module.exports = __webpack_public_path__ + "img/marco-hernandez.fa3bc822.png";